import _v from "./v1";
import _v2 from "./v4";
var exports = {};
var v1 = _v;
var v4 = _v2;
var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;
exports = uuid;
export default exports;